import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Box, Image } from "src/UILibrary"
import { MoveToTopButton } from "./MoveToTopButton"
import { LogoutButton } from "./LogoutButton"
import { useMediaQuery } from "react-responsive"
import { useNavigate } from "react-router-dom"
import { useLoginContext } from "src/hooks/useLoginContext"
import DensityMediumIcon from "@mui/icons-material/DensityMedium"
import LogoPNG from "src/assets/icons/logo.png"
import { Dayjs } from "dayjs"
import { MENU_TYPE, SUB_MENU_TYPE } from "src/modules/const"
import { ConsultSearchItem } from "./inbox/ConsultSearchItem"
import { EventSearchItem } from "./event/EventSearchItem"
import { NewsSearchItem } from "./news/NewsSearchItem"
import { UserSearchItem } from "./user/layout/UserSearchItem"

type Props = {
  mainMenuIndex?: number
  subMenuIndex?: number
  fromDate?: Dayjs | null
  handleFromDate?: any
  toDate?: Dayjs | null
  handleToDate?: any
  areaID?: number[]
  handleAreaID?: any
  categories?: number[]
  handleCategories?: any
}

export const TopMenuItem = ({
  mainMenuIndex,
  subMenuIndex,
  fromDate,
  handleFromDate,
  toDate,
  handleToDate,
  areaID,
  handleAreaID,
  categories,
  handleCategories,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.topmenu" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  const navigate = useNavigate()
  const { logout } = useLoginContext()
  const [topmenu, setTopMenu] = useState<boolean>(false)
  const [searchmenu, setSearchMenu] = useState<boolean>(false)

  const getSearchPanel = () => {
    if (
      (mainMenuIndex == MENU_TYPE.INBOX && subMenuIndex == SUB_MENU_TYPE.INBOX_CONSULT) ||
      (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE && subMenuIndex == SUB_MENU_TYPE.CONSULT_LIST) ||
      (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE &&
        subMenuIndex == SUB_MENU_TYPE.CONSULT_RESERVATION) ||
      (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE &&
        subMenuIndex == SUB_MENU_TYPE.CONSULT_ACCEPTED) ||
      (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE && subMenuIndex == SUB_MENU_TYPE.CONSULT_CANCEL) ||
      (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE && subMenuIndex == SUB_MENU_TYPE.CONSULT_RESIGNED)
    ) {
      return (
        <ConsultSearchItem
          fromDate={fromDate!}
          handleFromDate={handleFromDate!}
          toDate={toDate!}
          handleToDate={handleToDate!}
          areaID={areaID!}
          handleAreaID={handleAreaID!}
        />
      )
    }
    if (
      (mainMenuIndex == MENU_TYPE.INBOX && subMenuIndex == SUB_MENU_TYPE.INBOX_EVENT) ||
      (mainMenuIndex == MENU_TYPE.EVENT_MANAGE && subMenuIndex == SUB_MENU_TYPE.EVENT_LIST) ||
      (mainMenuIndex == MENU_TYPE.EVENT_MANAGE &&
        subMenuIndex == SUB_MENU_TYPE.EVENT_LIST_RECEIVING) ||
      (mainMenuIndex == MENU_TYPE.EVENT_MANAGE &&
        subMenuIndex == SUB_MENU_TYPE.EVENT_LIST_STARTED) ||
      (mainMenuIndex == MENU_TYPE.EVENT_MANAGE && subMenuIndex == SUB_MENU_TYPE.EVENT_LIST_ARCHIVED)
    ) {
      return (
        <EventSearchItem
          fromDate={fromDate!}
          handleFromDate={handleFromDate!}
          toDate={toDate!}
          handleToDate={handleToDate!}
          areaID={areaID!}
          handleAreaID={handleAreaID!}
          categories={categories!}
          handleCategories={handleCategories!}
        />
      )
    }

    if (
      (mainMenuIndex == MENU_TYPE.NEWS_MANAGE && subMenuIndex == SUB_MENU_TYPE.NEWS_ALL) ||
      (mainMenuIndex == MENU_TYPE.NEWS_MANAGE && subMenuIndex == SUB_MENU_TYPE.NEWS_NEWS) ||
      (mainMenuIndex == MENU_TYPE.NEWS_MANAGE && subMenuIndex == SUB_MENU_TYPE.NEWS_INTERVIEW)
    ) {
      return (
        <NewsSearchItem
          fromDate={fromDate!}
          handleFromDate={handleFromDate!}
          toDate={toDate!}
          handleToDate={handleToDate!}
        />
      )
    }

    if (
      (mainMenuIndex == MENU_TYPE.USER_MANAGE && subMenuIndex == SUB_MENU_TYPE.USER_LIST) ||
      (mainMenuIndex == MENU_TYPE.USER_MANAGE && subMenuIndex == SUB_MENU_TYPE.ADVISER_LIST) ||
      (mainMenuIndex == MENU_TYPE.USER_MANAGE && subMenuIndex == SUB_MENU_TYPE.COMPANY_LIST) ||
      (mainMenuIndex == MENU_TYPE.USER_MANAGE && subMenuIndex == SUB_MENU_TYPE.ADMINISTRATOR_LIST)
    ) {
      return <UserSearchItem areaID={areaID!} handleAreaID={handleAreaID!} />
    }

    return <></>
  }

  return (
    <Box
      display="flex"
      sx={{
        borderBottom: isTablet ? "" : "1px solid #f1f1f1",
        width: "100%",
      }}
    >
      <Box
        className="notosans weight700"
        fontSize={16}
        sx={{
          pl: isTablet ? "40px" : "15px",
          my: "auto",
          "&:hover": { cursor: "pointer" },
        }}
        onClick={() => navigate("/")}
      >
        <Image
          src={LogoPNG}
          imageStyle={{ height: "60px" }}
          sx={{ height: "60px", mr: "auto", cursor: "pointer", resizeMode: "cover" }}
        />
      </Box>
      {isTablet ? (
        <Box display="flex" sx={{ width: "auto", ml: "auto", pr: "40px" }}>
          <MoveToTopButton caption={t("move_to_top")} onClick={() => navigate("/")} />
          <LogoutButton
            caption={t("logout")}
            onClick={() => {
              logout()
              navigate("/")
            }}
          />
        </Box>
      ) : (
        <>
          {((mainMenuIndex == MENU_TYPE.INBOX && subMenuIndex == SUB_MENU_TYPE.INBOX_CONSULT) ||
            (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.CONSULT_LIST) ||
            (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.CONSULT_RESERVATION) ||
            (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.CONSULT_ACCEPTED) ||
            (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.CONSULT_CANCEL) ||
            (mainMenuIndex == MENU_TYPE.CONSULT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.CONSULT_RESIGNED) ||
            (mainMenuIndex == MENU_TYPE.INBOX && subMenuIndex == SUB_MENU_TYPE.INBOX_EVENT) ||
            (mainMenuIndex == MENU_TYPE.EVENT_MANAGE && subMenuIndex == SUB_MENU_TYPE.EVENT_LIST) ||
            (mainMenuIndex == MENU_TYPE.EVENT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.EVENT_LIST_RECEIVING) ||
            (mainMenuIndex == MENU_TYPE.EVENT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.EVENT_LIST_STARTED) ||
            (mainMenuIndex == MENU_TYPE.EVENT_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.EVENT_LIST_ARCHIVED) ||
            (mainMenuIndex == MENU_TYPE.NEWS_MANAGE && subMenuIndex == SUB_MENU_TYPE.NEWS_ALL) ||
            (mainMenuIndex == MENU_TYPE.NEWS_MANAGE && subMenuIndex == SUB_MENU_TYPE.NEWS_NEWS) ||
            (mainMenuIndex == MENU_TYPE.NEWS_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.NEWS_INTERVIEW) ||
            (mainMenuIndex == MENU_TYPE.USER_MANAGE && subMenuIndex == SUB_MENU_TYPE.USER_LIST) ||
            (mainMenuIndex == MENU_TYPE.USER_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.ADVISER_LIST) ||
            (mainMenuIndex == MENU_TYPE.USER_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.COMPANY_LIST) ||
            (mainMenuIndex == MENU_TYPE.USER_MANAGE &&
              subMenuIndex == SUB_MENU_TYPE.ADMINISTRATOR_LIST)) && (
            <Box
              className="notosans weight700 condition_search"
              display="flex"
              sx={{
                width: "auto",
                ml: "auto",
                mt: "20px",
                opacity: topmenu ? 0.8 : 1,
              }}
              onClick={() => {
                setSearchMenu(!searchmenu)
                setTopMenu(false)
              }}
            >
              {t("condition_search")}
            </Box>
          )}
          <Box
            className="notosans weight700"
            display="flex"
            sx={{
              width: "auto",
              ml: "auto",
              mt: "20px",
              pr: "26px",
              opacity: topmenu ? 0.8 : 1,
            }}
            onClick={() => {
              setTopMenu(!topmenu)
              setSearchMenu(false)
            }}
          >
            <DensityMediumIcon sx={{ mr: "10px" }} />
            {"MENU"}
          </Box>
          {topmenu ? (
            <Box sx={{ width: "100%", position: "absolute", top: "60px", zIndex: "1" }}>
              <Box
                sx={{
                  width: "100%",
                  height: "60px",
                  borderTop: "1px solid grey",
                  borderBottom: "1px solid grey",
                  bgcolor: "white",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans JP!important",
                }}
                onClick={() => navigate("/")}
              >
                {t("to_top")}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "60px",
                  borderBottom: "1px solid grey",
                  bgcolor: "white",
                  color: "#1F6757",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans JP!important",
                }}
                onClick={() => {
                  logout()
                  navigate("/")
                }}
              >
                {t("logout")}
              </Box>
            </Box>
          ) : (
            <></>
          )}

          {searchmenu ? (
            <Box
              sx={{
                width: "100%",
                position: "absolute",
                top: "60px",
                zIndex: "1",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "auto",
                  borderTop: "1px solid grey",
                  borderBottom: "1px solid grey",
                  bgcolor: "#F8F8F8",
                  display: "flex",
                  // justifyContent: "center",
                  // alignItems: "center",
                  p: "15px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  fontFamily: "Noto Sans JP!important",
                }}
              >
                {getSearchPanel()}
              </Box>
            </Box>
          ) : (
            <></>
          )}
        </>
      )}
    </Box>
  )
}
